export const NEXT_TICK_MS = 0
export const ANIMATION_DURATION_MS = 300
export const MOUNT_DELAY_MS = 10
export const TOAST_DISMISS_MS = 5000
export const COUNTDOWN_SECONDS = 60
export const COUNTDOWN_INTERVAL_MS = 1000
export const SLIDER_AUTO_LOOP_DELAY_MS = 3000
export const MOBILE_BREAKPOINT_PX = 768
export const SEARCH_DEBOUNCE_MS = 400
export const SCROLL_DELAY_MS = 100
